import React, { useEffect, useRef, useState } from 'react'
import { Modal, Input, Tooltip } from 'antd'
import { Check, Copy } from 'lucide-react'
import Button from '../../components/Button'
import { branchLink } from './branchLink'
import { copyText } from './clipboard'


const BranchModal = ({ open, branch, onSubmit, onCancel }) => {
	const [name, setName] = useState('')
	const [error, setError] = useState('')
	const [saving, setSaving] = useState(false)
	const [copied, setCopied] = useState(false)
	const copiedTimer = useRef()

	useEffect(() => {
		if (open) {
			setName(branch?.name || '')
			setError('')
			setSaving(false)
			setCopied(false)
		}
	}, [open, branch])

	useEffect(() => () => clearTimeout(copiedTimer.current), [])

	// Havola bazadagi nomdan yasaladi — inputdagi tahrirlanmagan matndan emas
	const link = branch?.name ? branchLink(branch.name) : ''

	const copyLink = async () => {
		try {
			await copyText(link)
			setCopied(true)
			clearTimeout(copiedTimer.current)
			copiedTimer.current = setTimeout(() => setCopied(false), 2000)
		} catch (e) {
			setError('Havolani nusxalab bo‘lmadi')
		}
	}

	const submit = async () => {
		if (saving) return
		const trimmed = name.trim()
		if (!trimmed) {
			setError('Filial nomini kiriting')
			return
		}
		setSaving(true)
		try {
			const ok = await onSubmit(trimmed)
			if (!ok) setSaving(false)
		} catch (e) {
			setSaving(false)
		}
	}

	return (
		<Modal
			open={open}
			title={branch ? 'Filial nomini o‘zgartirish' : 'Filial qo‘shish'}
			onCancel={saving ? undefined : onCancel}
			footer={null}
			destroyOnClose
			maskClosable={!saving}
		>
			<div className="flex flex-col gap-2 mt-4">
				<label className="text-sm font-medium">Nomi</label>
				<Input
					autoFocus
					value={name}
					maxLength={100}
					status={error ? 'error' : ''}
					placeholder="Masalan: Chilonzor"
					onChange={(e) => {
						setName(e.target.value)
						if (error) setError('')
					}}
					onPressEnter={submit}
					disabled={saving}
				/>
				{error && <p className="text-red-500 text-sm">{error}</p>}
			</div>
			{link && (
				<div className="flex flex-col gap-2 mt-4">
					<label className="text-sm font-medium">Mijozga yuboriladigan havola</label>
					<div className="flex gap-2">
						<Input value={link} readOnly onFocus={(e) => e.target.select()} />
						<Tooltip title={copied ? 'Nusxalandi ✓' : 'Havolani nusxalash'}>
							<button
								type="button"
								className="px-3 rounded border border-gray-300 hover:bg-gray-100 text-gray-600"
								onClick={copyLink}
							>
								{copied ? (
									<Check size={16} className="text-green-600" />
								) : (
									<Copy size={16} />
								)}
							</button>
						</Tooltip>
					</div>
					<p className="text-xs text-gray-500">
						Filial nomi o‘zgartirilsa havola ham o‘zgaradi — yangisini qayta tarqating.
					</p>
				</div>
			)}
			<div className="flex justify-end gap-2 mt-6">
				<Button
					className="!h-10 !bg-gray-400"
					onClick={onCancel}
					disabled={saving}
				>
					Bekor qilish
				</Button>
				<Button className="!h-10" onClick={submit} isLoading={saving}>
					Saqlash
				</Button>
			</div>
		</Modal>
	)
}

export default BranchModal
